export default "__VITE_ASSET__D_poGxVz__"